<template>
  <div class="md:grid md:grid-cols-5 md:gap-4 md:items-start">
    <div class="md:col-span-2">
      <div class="border-brand-sand border-2 p-8 rounded-md bg-white">
        <p class="title">Customize Your Design</p>
        <el-divider class="bg-brand-sand"></el-divider>
        <div class="mt-6">
          <p class="mt-3 mb-2 font-semibold text-sm font-gray-700">Select Theme</p>
          <el-select :value="calculatedBranding.brandTheme" @input="(brandTheme) => setOrgBranding({ brandTheme })">
            <el-option label="Basic" value="default" class="capitalize">Basic</el-option>
            <el-option label="Dynamic" value="theme-v2" class="capitalize">Dynamic</el-option>
          </el-select>
          <p class="mt-4 mb-2 font-semibold text-sm font-gray-700">Primary Color</p>
          <el-color-picker :value="calculatedBranding.primaryColor || '#4a4a4f'" @change="(primaryColor) => setOrgBranding({ primaryColor })" />
          <p v-if="calculatedBranding.brandTheme === 'default'" class="mt-3 mb-2 font-semibold text-sm font-gray-700">Logo URL</p>
          <el-input
            v-if="calculatedBranding.brandTheme === 'default'"
            :value="calculatedBranding.brandImage"
            @input="(brandImage) => setOrgBranding({ brandImage })"
          ></el-input>
          <!-- Switch for Confetti -->
          <p class="mt-4 mb-2 font-semibold text-sm font-gray-700">Confetti When Customer Accepts Offer</p>
          <el-switch
            :key="calculatedBranding.primaryColor"
            v-model="calculatedBranding.confetti"
            @change="(confetti) => setOrgBranding({ confetti })"
            :active-color="calculatedBranding.primaryColor || '#4a4a4f'"
            inactive-color="#D0C8C0"
          ></el-switch>
        </div>
      </div>
      <!-- <div class="hidden mt-4">
        <div class="shadow-md rounded-lg flex justify-center space-x-2 cursor-pointer py-3 items-center hover:shadow-lg transition-all" @click="preview">
          <span class="pulse mx-2"></span>
          <span class="text-brand-blue text-sm font-bold">Launch Live Preview</span>
        </div>
      </div> -->
      <!--
      <div class="mt-4">
        <button
          :style="{ background: '#4a4a4f' }"
          type="button"
          class="w-full flex-grow px-6 py-3 text-base leading-6 font-medium rounded-md shadow-md text-white hover:opacity-75 transition ease-in-out duration-150"
          @click="testMergeFields"
        >
          <div class="flex justify-center space-x-2 cursor-pointer items-center transition-all">
            <span class="text-white text-sm font-bold">Test Merge Fields</span>
          </div>
        </button>
      </div>
      -->
      <div class="mt-4">
        <button
          :style="{ background: calculatedBranding.primaryColor || '#4a4a4f' }"
          type="button"
          class="w-full flex-grow px-6 py-3 text-base leading-6 font-medium rounded-md shadow-md text-white hover:opacity-75 transition ease-in-out duration-150"
          @click="preview"
        >
          <div class="flex justify-center space-x-2 cursor-pointer items-center transition-all">
            <span class="pulse mx-2"></span>
            <span class="text-white text-sm font-bold">Launch Live Preview</span>
          </div>
        </button>
      </div>
    </div>
    <div class="md:mt-0 md:col-span-3">
      <design-preview
        :branding="{
          primaryColor: calculatedBranding.primaryColor,
          brandImage: calculatedBranding.brandImage,
        }"
      />
      <!--
      <p class="text-center text-sm text-gray-400 mt-4">Design sample (not using your flow)</p>
      -->
    </div>
  </div>
</template>

<script>
import ConfettiGenerator from 'confetti-js';
import DesignPreview from '@/components/Cancellation/Design/DesignPreview.vue';
import * as actions from '@/store/action-types';
import * as mutations from '@/store/mutation-types';

import { LAUNCH_EMBED_PREVIEW, LAUNCH_INLINE_PREVIEW } from '@/store/action-types';

export default {
  name: 'CancellationDesign',
  components: {
    DesignPreview,
  },
  data() {
    return {
      confetti: null,
      confettiTimeout: null,
    };
  },
  computed: {
    currentBlueprint() {
      return this.$store.getters.currentBlueprint;
    },
    sampleBlueprintId() {
      return this.$store.getters.primaryBlueprintId;
    },
    orgBranding() {
      return this.$store.state.org?.branding || { primaryColor: '#4a4a4f' };
    },
    calculatedBranding() {
      return {
        ...this.currentBlueprint,
        ...this.$store.state.org?.branding,
      };
    },
  },
  mounted() {
    if (this.sampleBlueprintId) {
      this.$store.dispatch(LAUNCH_INLINE_PREVIEW, { blueprintId: this.sampleBlueprintId });
    }
  },
  methods: {
    saveOrgBranding() {
      this.$store.dispatch(actions.ORG_BRANDING_UPDATE);
    },

    setMergeFieldsPreview(fields) {
      this.$store.commit(mutations.SET_PREVIEW_MERGE_FIELDS, fields);
      if (fields) {
        if (window.churnkey?.updateCustomerAttributes) {
          window.churnkey.updateCustomerAttributes(fields);
        }
      }
    },

    setOrgBranding(update) {
      this.$store.commit(mutations.SET_ORG_DETAILS, { branding: { ...this.orgBranding, ...update } });
      if (update.primaryColor) {
        if (window.churnkey?.updateBranding) {
          window.churnkey.updateBranding({
            colors: {
              primary: this.orgBranding.primaryColor,
            },
          });
        }
      }
      if (update.brandImage || update.brandTheme || update.confetti !== undefined) {
        this.$store.dispatch(LAUNCH_INLINE_PREVIEW, { blueprintId: this.sampleBlueprintId });
      }
      if (update.confetti !== undefined) {
        if (update.confetti === false) {
          this.removeConfetti();
        } else if (update.confetti === true) {
          this.previewConfetti();
        }
      }
      this.saveOrgBranding();
    },
    preview() {
      if (this.sampleBlueprintId) {
        this.$store.commit(mutations.SET_PREVIEW_INLINE, false);
        this.$store.dispatch(LAUNCH_EMBED_PREVIEW, { blueprintId: this.sampleBlueprintId });
      }
    },
    testMergeFields() {
      const subscriptionStart = new Date();
      subscriptionStart.setDate(subscriptionStart.getDate() - 90);
      this.setMergeFieldsPreview({
        CUSTOMER_NAME: 'John Doe',
        num_videos: 6,
        favorite_product: 'My fav product',
        signup_date: '12/30/2021',
        SUBSCRIPTION_AGE: '3 months',
        PRICE: '$19.99',
        BILLING_INTERVAL: 'month',
        SUBSCRIPTION_STATUS: 'Active',
        SUBSCRIPTION_START_DATE: subscriptionStart.toLocaleDateString(),
        'CUSTOMER_NAME.FIRST': 'Jane',
        'CUSTOMER_NAME.LAST': 'Doe',
        SUBSCRIPTION_PRICE: '$45 / month',
      });
    },
    previewConfetti() {
      this.addConfettiCanvas();
      const confettiElement = document.getElementById('confetti-holder');
      const confettiSettings = { target: confettiElement, respawn: false, max: 1500, clock: 70 };
      this.confetti = new ConfettiGenerator(confettiSettings);
      this.confetti.render();
      this.confettiTimeout = setTimeout(() => {
        this.removeConfetti();
      }, 4000);
    },
    removeConfetti() {
      clearTimeout(this.confettiTimeout);
      if (this.confetti) {
        this.confetti.clear();
        const canv = document.getElementById('confetti-holder');
        if (canv) {
          canv.remove();
        }
      }
    },
    addConfettiCanvas() {
      const canv = document.createElement('canvas');
      canv.id = 'confetti-holder';
      canv.style.cssText = 'height:calc(100vh + 400px);width:100vw;position:absolute; z-index: 45; top: -400px;pointer-events:none;';
      document.body.insertBefore(canv, document.body.firstChild);
    },
  },
};
</script>

<style lang="scss" scoped>
.pulse {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #ffffff;
  cursor: pointer;
  box-shadow: 0 0 0 #ffffff77;
  animation: pulse 1.5s infinite;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 #ffffff77;
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 #ffffff77;
    box-shadow: 0 0 0 0 #ffffff77;
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}
</style>
